import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Row, Col } from 'react-bootstrap';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import Search from './search';
import { handleChangeDataSearchBranchAutoComplete } from '../../../../redux/actions/partials/search/searchBranch';

const SearchBranch = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");

    useEffect(() => {
        if(type === undefined || (type !== 'buy' && type !== 'upload'))
            navigate('../installments');
        // eslint-disable-next-line
    }, [SearchBranch]);


    const handleBackBtn = () => {
        dispatch(handleChangeDataSearchBranchAutoComplete('text', ''));
        dispatch(handleChangeDataSearchBranchAutoComplete('result', []));
        navigate(-1);
    };



    return (

        <div id="search-branch-installmen-page">
            <Row className="pt-5 white-bg sticky top-0 z-index-2">
                <Col xs={1} className="d-flex align-items-center"><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10} className="text-center">
                    <div className="header_h3">
                        فروشگاه مورد نظر جهت  خرید اقساطی   را جستجو و انتخاب کنید
                    </div>
                </Col>
                <Col xs={1}></Col>
                <Col xs={12} className="header_h4 font-weight-300 text-center mt-1">
                    (در انتخاب شعبه فروشگاه دقت فرمایید)
                </Col>
            </Row>

            <Row className="mt-4">
                <Col>
                    <Search type={type} />
                </Col>
            </Row>

        

        </div>

    );
}

export default SearchBranch;